// extracted by mini-css-extract-plugin
export var clauseRow = "_bo-6";
export var emptyState = "_bo-d";
export var filterContent = "_bo-a";
export var filterGroup = "_bo-1";
export var filterGroupContainer = "_bo-0";
export var nestedGroup = "_bo-2";
export var nestedGroupContent = "_bo-b";
export var nestedGroupDepth1 = "_bo-3";
export var nestedGroupDepth2 = "_bo-4";
export var nestedGroupDepth3 = "_bo-5";
export var nestedGroupEmpty = "_bo-c";
export var operatorAnd = "_bo-8";
export var operatorOr = "_bo-9";
export var operatorToggle = "_bo-7";
export var removeGroupButton = "_bo-e";